import { webCampaign } from '@/modules/webCampaign';
import { AI_DATA } from '@/pages/Onboarding/constants';

export const getMainImageSrc = () => {
  return AI_DATA[webCampaign.aiType].paywallV2.mainImgSrc;
};
